<template>
  <div>
    <vue-headful title="Locatie" />
    <Header page_title="Locatie" />
    <div>
      <div v-if="false" class="px-4 mx-2 pb-4">
        <div class="container-fluid px-0">
          <NotificationContainer />
          <div class="form-group w-square-icon mb-1">
            <gmap-autocomplete
              @place_changed="setPlace"
              placeholder="Zoek met Google Maps"
              class="form-control"
            ></gmap-autocomplete>
            <div class="icon-wrapper search position-absolute align-self-center">
              <i class="material-icons">place</i>
            </div>
          </div>
        </div>
      </div>
      <form @change="onFormChange" @submit.prevent="onSubmit">
        <div v-if="false" class="mb-4 pb-1">
          <gmap-map
            v-if="center"
            :center="center"
            :zoom="6.5"
            :options="{
              mapTypeControl: false,
              scaleControl: false,
              disableDefaultUi: false,
              streetViewControl: false,
              fullscreenControl: false,
              scrollwheel: false,
              disableDoubleClickZoom: true,
              clickableIcons: false,
              styles: [
                {
                  stylers: [
                    {
                      saturation: -100
                    }
                  ]
                }
              ]
            }"
            style="width:100%;  height: 250px;"
          >
            <gmap-marker
              :position="marker.position"
              :draggable="draggable"
              @dragend="getMarkerPosition($event.latLng)"
            ></gmap-marker>
            <GmapCircle
              v-if="user"
              :center="center"
              :radius="parseInt(user.search_distance + `000`)"
              :visible="true"
              :options="{
                strokeColor: '#FFCD00',
                strokeOpacity: 1,
                strokeWeight: 1.3,
                fillColor: '#FFCD00',
                fillOpacity: 0.1
              }"
            ></GmapCircle>
          </gmap-map>
        </div>
        <div class="px-4 mx-2 pb-4">
          <div class="container-fluid px-0 pb-1 mb-2">
            <div v-if="Object.keys(form).some(k => form[k])" class="mb-4">
              <p>
                <strong>Adresgegevens</strong>
              </p>
              <div class="row mb-3">
                <div class="col-6 pr-2">
                  <input
                    type="text"
                    class="form-control"
                    v-bind:class="[
                      this.required.includes('street') ? 'require' : ''
                    ]"
                    v-bind:placeholder="
                      'Straat' + [this.required.includes('street') ? ' *' : '']
                    "
                    v-model="form.street"
                    autocomplete="nope"
                    required
                  />
                </div>
                <div class="col-3 pl-2">
                  <input
                    type="text"
                    class="form-control"
                    v-bind:class="[
                      this.required.includes('street_number') ? 'require' : ''
                    ]"
                    v-bind:placeholder="
                      'Nummer' +
                        [this.required.includes('street_number') ? ' *' : '']
                    "
                    v-model="form.street_number"
                    autocomplete="nope"
                    required
                  />
                </div>
                <div class="col-3 pl-2">
                  <input
                    type="text"
                    class="form-control"
                    v-bind:placeholder="'Toevoeging'"
                    v-model="form.house_addition"
                    autocomplete="nope"
                  />
                </div>
              </div>
              <div class="row">
                <div class="col-5 pr-2">
                  <input
                    type="text"
                    class="form-control"
                    v-bind:class="[
                      this.required.includes('postal_code') ? 'require' : ''
                    ]"
                    v-bind:placeholder="
                      'Postcode' +
                        [this.required.includes('postal_code') ? ' *' : '']
                    "
                    v-model="form.postal_code"
                    autocomplete="nope"
                    required
                  />
                </div>
                <div class="col pl-2">
                  <input
                    type="text"
                    class="form-control"
                    v-bind:class="[
                      this.required.includes('city') ? 'require' : ''
                    ]"
                    v-bind:placeholder="
                      'Plaats' + [this.required.includes('city') ? ' *' : '']
                    "
                    v-model="form.city"
                    autocomplete="nope"
                    required
                  />
                </div>
              </div>
            </div>
            <Required />
            <button
              type="submit"
              class="btn btn-warning btn-block"
            >{{ user ? "Opslaan" : "Volgende" }}</button>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
export default {
  data: function() {
    return {
      user: null,
      required: "",
      form: {
        search_lat: "",
        search_lng: "",
        street: null,
        street_number: null,
        house_addition: null,
        postal_code: null,
        city: null
      },
      new_address: {
        street: null,
        street_number: null,
        house_addition: null,
        postal_code: null,
        city: null
      },
      draggable: true,
      center: null,
      marker: {},
      prevRoute: null
    };
  },
  async created() {},
  async mounted() {
    await this.fetchData();
  },
  watch: {
    $route: "fetchData"
  },
  methods: {
    async fetchData() {
      this.$store.state.loading = true;
      this.required = this.$store.state.applicant_fields;
      this.user = JSON.parse(localStorage.getItem("user"));

      await this.autoFillForm();

      if (!this.form.search_lat && !this.form.search_lng) {
        this.geolocate();
        // let address = await this.getAddress();
        // console.log(address);
        // let location = await this.getAddressLatLng(address);
        // await this.loadMap(location);
      } else {
        // console.log("2");
        this.setMap({
          lat: parseFloat(this.form.search_lat),
          lng: parseFloat(this.form.search_lng)
        });
        this.geolocate();
      }
      this.$store.state.loading = false;
    },
    async autoFillForm() {
      return new Promise(resolve => {
        const user = JSON.parse(localStorage.getItem("user"));
        // update the form obj from user
        if (user) {
          for (var obj in this.form) {
            if (user[obj]) {
              this.form[obj] = user[obj];
            }
          }
        } else {
          let new_address = JSON.parse(localStorage.getItem("address"));
          // check if the user is logged in
          if (new_address) {
            for (obj in new_address) {
              if (new_address[obj]) {
                this.form[obj] = new_address[obj];
              }
            }
            const marker = {
              lat: parseFloat(this.form.search_lat),
              lng: parseFloat(this.form.search_lng)
            };
            this.marker = { position: marker };
            this.center = marker;
            this.$forceUpdate();
          }
        }
        resolve();
      });
    },
    async getAddress() {
      return new Promise(resolve => {
        const user = JSON.parse(localStorage.getItem("user"));
        var user_address = {
          street: user.street,
          street_number: user.street_number,
          house_addition: user.house_addition,
          postal_code: user.postal_code,
          city: user.city
        };
        if (Object.keys(user_address).every(k => user_address[k])) {
          let place = [
            user.street,
            user.street_number + user.house_addition + ",",
            user.postal_code,
            user.city
          ].join(" ");
          return resolve(place);
        } else {
          return resolve(null);
        }
      });
    },
    async loadMap(loc) {
      return new Promise(resolve => {
        if (loc) {
          this.setMap(loc);
        } else {
          this.geolocate();
        }
        resolve();
      });
    },
    geolocate: function() {
      if (!this.center) {
        navigator.geolocation.getCurrentPosition(position => {
          const marker = {
            lat: position.coords.latitude,
            lng: position.coords.longitude
          };
          // this.setMap(marker);
          this.center = {
            lat: position.coords.latitude,
            lng: position.coords.longitude
          };
        });
        if (!this.center) {
          this.center = {
            lat: 52.1326,
            lng: 5.2913
          };
        }
      }
    },
    setMap(loc) {
      this.marker = { position: loc };
      this.center = loc;
      this.form.search_lat = loc.lat;
      this.form.search_lng = loc.lng;
    },
    setPlace(place) {
      this.currentPlace = place;
      this.addMarker();
    },
    addMarker() {
      if (this.currentPlace) {
        this.updateNewAddress(this.currentPlace.address_components);
        const marker = {
          lat: this.currentPlace.geometry.location.lat(),
          lng: this.currentPlace.geometry.location.lng()
        };
        this.setMap(marker);
      }
    },
    updateNewAddress(results) {
      let arr = results;
      var components = {};
      jQuery.each(arr, function(k, v1) {
        jQuery.each(v1.types, function(k2, v2) {
          components[v2] = v1.short_name;
        });
      });
      // set new address
      var address = this.form;
      address["street"] = components.route ? components.route : null;
      address["street_number"] = components.street_number
        ? components.street_number
        : null;
      address["house_addition"] = components.house_addition
        ? components.house_addition
        : null;
      address["postal_code"] = components.postal_code
        ? components.postal_code
        : null;
      address["city"] = components.locality ? components.locality : null;
    },
    getMarkerPosition(marker) {
      // eslint-disable-next-line no-undef
      var geocoder = new google.maps.Geocoder();
      var form = this.form;
      var $this = this;
      geocoder.geocode(
        {
          latLng: {
            lat: marker.lat(),
            lng: marker.lng()
          }
        },
        function(results, status) {
          // eslint-disable-next-line no-undef
          if (status == google.maps.GeocoderStatus.OK) {
            if (results[0]) {
              $this.updateNewAddress(results[0].address_components);
              // set lat lng
              form["search_lat"] = marker.lat();
              form["search_lng"] = marker.lng();
              localStorage.setItem("form-pending", JSON.stringify(true));
            }
          }
        }
      );
      // set it back to center
      if (form["search_lat"] && form["search_lng"]) {
        this.center = {
          lat: marker.lat(),
          lng: marker.lng()
        };
      }
    },
    async updateUserLocation() {
      return new Promise((resolve, reject) => {
        var user_token = JSON.parse(localStorage.getItem("user-token"));
        var url = this.$apiURI + "/location";
        let formData = new FormData();
        for (var obj in this.form) {
          formData.append(obj, this.form[obj]);
        }
        this.$http
          .post(url, formData, {
            headers: {
              Authorization: "Bearer " + user_token,
              Accept: "application/json"
            }
          })
          .then(() => {
            // console.log(success);
            localStorage.removeItem("form-pending");
            const notification = {
              type: "success",
              message: "Je hebt je gegevens succesvol aangepast. "
            };
            this.$store.dispatch("notification/replace", notification, {
              root: true
            });
            this.$store.state.loading = false;
            resolve();
          })
          .catch(() => {
            // console.log(error);
            const notification = {
              type: "danger",
              message: "Er is een fout opgetreden."
            };
            this.$store.dispatch("notification/replace", notification, {
              root: true
            });
            this.$store.state.loading = false;
            reject();
          });
      });
    },
    async updateUserAddress() {
      return new Promise((resolve, reject) => {
        var user_token = JSON.parse(localStorage.getItem("user-token"));
        var url = this.$apiURI + "/applicant";
        let formData = new FormData();
        for (var obj in this.form) {
          var _val = this.form[obj];
          if (_val == null) {
            _val = "";
          }
          formData.append(obj, _val);
        }
        this.$http
          .post(url, formData, {
            headers: {
              Authorization: "Bearer " + user_token,
              Accept: "application/json"
            }
          })
          .then(() => {
            const notification = {
              type: "success",
              message: "Je hebt je gegevens succesvol aangepast. "
            };
            this.$store.dispatch("notification/replace", notification, {
              root: true
            });
            this.$store.state.loading = false;
            resolve();
          })
          .catch(() => {
            const notification = {
              type: "danger",
              message: "Er is een fout opgetreden."
            };
            this.$store.dispatch("notification/replace", notification, {
              root: true
            });
            this.$store.state.loading = false;
            reject();
          });
      });
    },
    async redirectBack() {
      return new Promise(() => {
        setTimeout(
          () =>
            this.$router.replace({
              name: this.prevRoute.name
            }),
          800
        );
      });
    },
    async onSubmit() {
      let geo = await this.geocode();
      if (geo.status) {
        if (this.user) {
          window.scrollTo(0, 0);
          this.updateUserAddress().then(() => {
            localStorage.removeItem("form-pending");
            this.updateLocalUser();
          });
        } else {
          localStorage.setItem("address", JSON.stringify(this.form));
        }
        this.redirectBack();
      }
    },
    onFormChange() {
      localStorage.setItem("form-pending", JSON.stringify(true));
    },
        async geocode() {
      return new Promise(resolve => {
        this.$gmapApiPromiseLazy().then(() => {
         const geocoder = new google.maps.Geocoder();
         var form = this.form;
         const address = this.form.street_number + "+" + this.form.street + "+" + this.form.postal_code + "+" + this.form.city;
 
         geocoder.geocode({ address }, function(results, status) {
           if (status === "OK") {
             const latitude = results[0].geometry.location.lat();
             const longitude = results[0].geometry.location.lng();
             form["search_lat"] = latitude;
             form["search_lng"] = longitude;
             resolve({status:'ok'});
           } else {
              resolve({status:'fail'}); 
           }
         });
       }).catch(() => {
         resolve({status:'fail'});
       });
      });
    }
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.prevRoute = from;
    });
  },
  beforeRouteLeave(to, from, next) {
    // this.savePending(to, from, next);
    if (this.user) {
      this.savePending(to, from, next);
    } else {
      next();
    }
  },
  computed: {}
};
</script>

<style scoped>
input.hidden {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: -1;
}
</style>
